import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Формат размера в метрах для отображения:
 * — < 1 м → сантиметры (50 см, 8 см)
 * — ≥ 1 м → метры с запятой (1 м, 1,2 м, 1,35 м), без лишних нулей
 */
export function formatDimension(meters) {
  if (meters == null || Number.isNaN(meters)) return '—';
  const m = Number(meters);
  if (m < 1) return Math.round(m * 100) + ' см';
  if (Number.isInteger(m)) return m + ' м';
  const s = m.toFixed(2).replace('.', ',').replace(/0+$/, '').replace(/,$/, '');
  return s + ' м';
}

/** Строка размеров: ширина × толщина × высота (каждый через formatDimension) */
export function formatDimensions(width, depth, height) {
  return `${formatDimension(width)} × ${formatDimension(depth)} × ${formatDimension(height)}`;
}
